import { render, staticRenderFns } from "./GroupListTemplateItem.vue?vue&type=template&id=f4c0ccd6&"
import script from "./GroupListTemplateItem.vue?vue&type=script&lang=ts&"
export * from "./GroupListTemplateItem.vue?vue&type=script&lang=ts&"
import style0 from "./GroupListTemplateItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports